import React from "react";
// Hook form
import { FieldValues, UseControllerReturn } from "react-hook-form";
// Material
import FormControlLabel, {
  FormControlLabelProps,
} from "@mui/material/FormControlLabel";
// Say Lib
import Switch from "../../../Atoms/Inputs/Switch";
import ErrorMessage from "../../../Atoms/ErrorMessage";
// Utils
import withControl from "../../../../hoc/withFormControl";

export type IHookSwitch = Omit<FormControlLabelProps, "control"> & {
  SwitchProps?: { [key: string]: string };
  name: string;
  controllerFields: UseControllerReturn<FieldValues, string>;
  callback?: (event: React.SyntheticEvent<Element, Event>) => void;
};

/**
 * @param SwitchProps - in case we need switch access
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
const HookSwitch = ({
  SwitchProps = {},
  name,
  callback,
  controllerFields: {
    field: { ref, onChange, value, ...inputProps },
    // fieldState: { invalid, isTouched, isDirty }, <- future use
    formState: { errors }, //touchedFields, dirtyFields }, <- future use
  },
  ...rest
}: IHookSwitch): JSX.Element => {
  /**
   * trigger side-effect if needed
   */
  const handleChange = (e: React.SyntheticEvent<Element, Event>) => {
    if (callback) {
      callback(e);
    }
    onChange(e);
  };

  return (
    <div>
      <FormControlLabel
        inputRef={ref}
        control={<Switch {...SwitchProps} />}
        onChange={handleChange}
        value={value}
        {...inputProps}
        {...rest}
      />
      <div>
        <ErrorMessage errors={errors} name={name} />
      </div>
    </div>
  );
};

export default withControl(HookSwitch);
